module.exports = __webpack_public_path__ + "static/img/11areaA_06.51cdc28.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/11areaA_06.png
// module id = 962
// module chunks = 1